// extracted by mini-css-extract-plugin
export var attachment = "_n6-a";
export var emailContainer = "_n6-4";
export var emailContentPaddedContainer = "_n6-b";
export var emailHeader = "_n6-6";
export var emailIframe = "_n6-3";
export var emailInfoIcon = "_n6-9";
export var emailShortenedSummary = "_n6-e";
export var infoDropdown = "_n6-0";
export var infoRowBoundedContent = "_n6-d";
export var internal = "_n6-5";
export var merchant = "_n6-8";
export var messageInputContainer = "_n6-h";
export var normal = "_n6-7";
export var replyCard = "_n6-f";
export var subtleButton = "_n6-1";
export var subtleButtonIconContainer = "_n6-2";
export var toggleViewRepliesButton = "_n6-c";
export var wrappingText = "_n6-g";